<template>
  <div>
    <v-card class="mx-auto">
      <v-toolbar color="green darken-3" dense dark>
        <v-icon>mdi-qrcode</v-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title class="font-weight-bold">
          INFORMAÇÕES DO PRODUTO - QRCODE
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container class="mt-4 pb-4 pe-4">
        <ProductHeader :productSelected="productSelected" />
        <v-row>
          <v-col cols="12" md="7">
            <ProductImage
              :productSelected="productSelected"
              pageOrigin="book"
            />
          </v-col>
          <v-col cols="12" md="5">
            <v-row>
              <v-col cols="12" md="10">
                <label class="text-h6">{{ productSelected.name }}</label>
              </v-col>
              <v-col cols="12" md="2">
                <!-- <v-btn
                  color="black"
                  outlined
                  @click="() => (page = 'produtos')"
                  left
                  small
                  dark
                  style="float: right"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  Voltar
                </v-btn> -->
              </v-col>
            </v-row>
            <v-row>
              <ProductDetails :productSelected="productSelected" />
            </v-row>
            <ProductAnotherColors
              :productSelected="productSelected"
              :products="products"
              :showAnotherProduct="showDetailsProduct"
            />
            <v-row>
              <v-col class="mt-2 pt-2">
                <label class="text-h6 text-weight-black">Tipo de Pedido:</label>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col class="mt-0 pt-0">
                <div
                  v-for="size in sizes"
                  :key="size.size"
                  style="width: 50px; float: left; margin-right: 5px"
                  class="py-0"
                >
                  <label style="padding-left: 15px">{{ size }}</label>
                  <v-text-field outlined dense hide-details></v-text-field>
                </div>
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col>
                <label class="text-h5">
                  {{ 200 | currencyEuaToBr }}
                </label>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col class="mb-3" cols="12" xs="12" sm="8" md="8" lg="8">
                <v-btn color="blue-grey darken-3" dark block>
                  <v-icon left>mdi-cart-outline</v-icon>
                  Planejamento - {{ 200 | currencyEuaToBr }}
                </v-btn>
              </v-col>
              <!-- <v-col>
                {{ 200 | currencyEuaToBr }}
              </v-col> -->
            </v-row>
            <v-row>
              <v-col class="mb-3" cols="12" xs="12" sm="8" md="8" lg="8">
                <v-btn color="blue ligthen-2" dark block>
                  <v-icon left>mdi-cart-outline</v-icon>
                  Pronta Entrega Express - {{ 200 | currencyEuaToBr }}
                </v-btn>
              </v-col>
              <!-- <v-col>
                {{ 190 | currencyEuaToBr }}
              </v-col> -->
            </v-row>
            <v-row v-if="productSelected.collection !== 'OUTONO INVERNO 2023'">
              <v-col>
                <v-alert
                  border="left"
                  color="red lighten-2"
                  dark
                  dense
                  icon="mdi-alert"
                  text
                >
                  <label class="font-weight-bold">
                    Este produto não é da coleção atual, sujeito a alteração de
                    preço e disponibilidade.
                  </label>
                </v-alert>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" xs="12" sm="8" md="8" lg="8">
                <v-btn color="green darken-4" dark block>
                  <v-icon left>mdi-cart-outline</v-icon>
                  Oportunidade
                </v-btn>
              </v-col>
            </v-row> -->
            <ProductTechnicalDetails :productSelected="productSelected" />
            <ProductTechnologies :productSelected="productSelected" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ProductImage from "@/components/Book/ProductImage";
import ProductHeader from "@/components/Book/ProductHeader";
import ProductDetails from "@/components/Book/ProductDetails";
import ProductAnotherColors from "@/components/Book/ProductAnotherColors";
import ProductTechnicalDetails from "@/components/Book/ProductTechnicalDetails";
import ProductTechnologies from "@/components/Book/ProductTechnologies";

export default {
  components: {
    ProductImage,
    ProductHeader,
    ProductDetails,
    ProductAnotherColors,
    ProductTechnicalDetails,
    ProductTechnologies,
  },
  data: () => ({
    products: [
      {
        id: 1,
        name: "SAPATO REF02483184",
        reference: "0248 3184",
        material: "TESTONE - VAQUILHONA",
        color: "PRETO - PRETO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: true,
        opportunity: true,
        release: true,
        technologies: [
          {
            name: "sense",
            image:
              "http://137.184.21.108/app/public/storage/images/technologies/q1BjmbKW44iIe2NTKAxYHZ5yIW0uY8VJqd5wAOJR.png",
            description:
              "Descrição completa sobre o que é a tecnologia Sense, explicando os beneficios e diferenciais",
          },
          {
            name: "gel",
            image:
              "http://137.184.21.108/app/public/storage/images/technologies/mcJA9cwURjYGRyZzBbfKNe3XOjUhhBUZeTwqjAVc.png",
            description:
              "Descrição completa sobre o que é a tecnologia Gel, explicando os beneficios e diferenciais",
          },
        ],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3184_04.jpg",
        ],
        parents: [3, 11],
      },
      {
        id: 2,
        name: "SAPATO REF005612420",
        reference: "0056 12420",
        material: "MESTIÇO VEGETAL",
        color: "PRETO",
        provider: "0056 - FRANK",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: true,
        opportunity: true,
        release: true,
        technologies: [
          {
            name: "sense",
            image:
              "http://137.184.21.108/app/public/storage/images/technologies/q1BjmbKW44iIe2NTKAxYHZ5yIW0uY8VJqd5wAOJR.png",
            description:
              "Descrição completa sobre o que é a tecnologia Sense, explicando os beneficios e diferenciais",
          },
        ],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/10/0056_12420_02.jpg",
        ],
        parents: [],
      },
      {
        id: 3,
        name: "SAPATO REF005612430",
        reference: "0056 12430",
        material: "MESTIÇO VEGETAL",
        color: "CAFE",
        provider: "0056 - FRANK",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        opportunity: false,
        release: false,
        technologies: [
          {
            name: "gel",
            image:
              "http://137.184.21.108/app/public/storage/images/technologies/mcJA9cwURjYGRyZzBbfKNe3XOjUhhBUZeTwqjAVc.png",
            description:
              "Descrição completa sobre o que é a tecnologia Gel, explicando os beneficios e diferenciais",
          },
        ],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/10/0056_12430_01.jpg",
        ],
        parents: [],
      },
      {
        id: 4,
        name: "SAPATO REF02483184",
        reference: "0248 3184",
        material: "TESTONE - VAQUILHONA",
        color: "TAN - TAN",
        provider: "0248 - PG4",
        collection: "PRIMAVERA VERÃO 2022/2023",
        collection_color: "#50723C",
        marketing: false,
        release: false,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3184_03.jpg",
        ],
        parents: [0, 11],
      },
      {
        id: 5,
        name: "SAPATO REF02483189",
        reference: "0248 3189",
        material: "VAQUILHONA - FIT",
        color: "PRETO - PRETO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2020",
        collection_color: "#823038",
        marketing: true,
        release: false,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3189_03.jpg",
        ],
        parents: [5],
      },
      {
        id: 6,
        name: "SAPATO REF02483189",
        reference: "0248 3189",
        material: "VAQUILHONA - FIT",
        color: "TAN - TAN",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: true,
        opportunity: false,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3189_02.jpg",
        ],
        parents: [4],
      },
      {
        id: 7,
        name: "SAPATO REF02483190",
        reference: "0248 3190",
        material: "CERVIATTO",
        color: "TAN",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: true,
        release: true,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3190_01INV%2023.jpg",
        ],
        parents: [7],
      },
      {
        id: 8,
        name: "SAPATO REF02483190",
        reference: "0248 3190",
        material: "CERVIATTO",
        color: "BROWN",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: false,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3190_03INV%2023.jpg",
        ],
        parents: [6],
      },
      {
        id: 9,
        name: "SAPATO REF02483552",
        reference: "0248 3552",
        material: "BASKO",
        color: "MOURO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: false,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3552_09.jpg",
        ],
        parents: [9],
      },
      {
        id: 10,
        name: "SAPATO REF02483552",
        reference: "0248 3552",
        material: "BASKO",
        color: "PRETO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: false,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3552_08.jpg",
        ],
        parents: [8],
      },
      {
        id: 11,
        name: "SAPATO REF02483553",
        reference: "0248 3553",
        material: "BASKO",
        color: "MOURO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: false,
        opportunity: true,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3553_09.jpg",
        ],
        parents: [],
      },
      {
        id: 12,
        name: "SAPATO REF02483562",
        reference: "0248 3562",
        material: "BASKO - BRUNELLO",
        color: "MOURO",
        provider: "0248 - PG4",
        collection: "OUTONO INVERNO 2023",
        collection_color: "#355070",
        marketing: false,
        release: false,
        opportunity: false,
        technologies: [],
        image: [
          "http://admbook.sergios.com.br/_lib/file/img/lines/1/18/0248_3562_08.jpg",
        ],
        parents: [0, 3],
      },
    ],
    productSelected: {},
  }),
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.productSelected = this.products[this.$route.params.id - 1];
      } else {
        this.productSelected = this.products[0];
      }
    },
    showDetailsProduct(product) {
      // console.log(product);
      this.$router.push({ path: `/produto/qrcode/${product.id}` });
      this.productSelected = product;
    },
  },
};
</script>
